import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const ConfirmModalContainer = styled.div(
	props => css`
		padding: 24px;
		
		.disabled {
			opacity: 0.5;
			cursor: not-allowed;ّ
		}

		.confirm_header {
			display: flex;
			align-items: center;
			justify-content: space-between;
			color: ${`var(--color-primary-text-${props.theme.mode})`};
			gap: 16px;
			padding-bottom: 16px;
			margin-bottom: 16px;
			border-bottom: ${`1px solid var(--color-primary-separator-${props.theme.mode})`};

			.title {
				font-weight: 500;
				font-size: 1rem;
				line-height: 20px;
			}

			svg {
				cursor: pointer;
				width: 20px;
				height: 20px;
			}
		}

		.confirm_body {
			display: flex;
			flex-direction: column;
			gap: 12px;
			margin-bottom: 32px;
			width: 100%;

			.separated_container {
				margin-top: 12px;
				.label {
					font-weight: 300;
					font-size: 14px;
					line-height: 17px;
					color: ${props.theme.colors.text.secondary};
					margin-bottom: 12px;

					strong {
						color: ${props.theme.colors.text.primary};
					}
				}

				.inputs_container {
					display: grid;
					grid-template-columns: repeat(6, 1fr);
					direction:ltr;
					gap: 8px;}
					.input_single_number {
						width: 34px;
						height: 40px;
						> div {
							border-radius: 8px;
						}
				
						input {
							min-width: unset;
							width: 34px;
							height: 40px;
							font-weight: 700;
							font-size: 24px;
							line-height: 34px;
							text-align: center;
							padding: 0;
						}
					}
				}

				.code_container {
					display: flex;
					align-items: center;
					justify-content: flex-end;
					margin-top: 16px;

					.get_code {
						color: #f5a42a;
						font-weight: 400;
						font-size: 16px;
						line-height: 20px;
						cursor: pointer;
					}
				}
			}

			.note_container {
				padding: 12px 16px;
				font-weight: 300;
				font-size: 0.875rem;
				margin-bottom: 16px;
				background: ${props.theme.mode === 'dark' ? '#211B00' : '#FEFAE6'};
				color: ${props.theme.mode === 'dark' ? '#FCD535' : '#322901'};
				border-radius: 4px;

				span {
					font-weight: 500;
				}
			}

			.email_otp,
			.phone_otp,
			.totp {
				width: 100%;
			}
		}

		.confirm_action {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 8px;
		}

		@media (min-width: 360px) {
			.confirm_body {
				.separated_container {
					margin-top: 12px;
					.label {
						font-weight: 300;
						font-size: 14px;
						line-height: 17px;
						color: ${props.theme.colors.text.secondary};
						margin-bottom: 12px;

						strong {
							color: ${props.theme.colors.text.primary};
						}
					}

					.inputs_container {
						display: grid;
						grid-template-columns: repeat(6, 1fr);
						gap: 8px;

						.input_single_number {
							width: 40px;
							height: 40px;
							> div {
								border-radius: 8px;
							}

							input {
								min-width: unset;
								height: 40px;
								width: 40px;
								font-weight: 700;
								font-size: 24px;
								line-height: 34px;
								text-align: center;
								padding: 0;
							}
						}
					}

					.code_container {
						display: flex;
						align-items: center;
						justify-content: flex-end;
						margin-top: 16px;

						.get_code {
							color: #f5a42a;
							font-weight: 400;
							font-size: 16px;
							line-height: 20px;
						}
					}
				}
			}
		}

		@media (min-width: 506px) {
			.confirm_header {
				.title {
					font-size: 1.25rem;
				}
			}

			.confirm_body {
				.separated_container {
					.inputs_container {
						display: grid;
						grid-template-columns: repeat(6, 1fr);
						gap: 8px;

						.input_single_number {
							width: 64px;
							height: 64px;
							> div {
								border-radius: 8px;
							}

							input {
								height: 64px;
								width: 64px;
								font-weight: 700;
								font-size: 28px;
								line-height: 34px;
								text-align: center;
								padding: 0;
							}
						}
					}
				}
			}
		}
	`,
);
